import { render, staticRenderFns } from "./DatabaseSearch.vue?vue&type=template&id=3d3b492a"
import script from "./DatabaseSearch.vue?vue&type=script&lang=js"
export * from "./DatabaseSearch.vue?vue&type=script&lang=js"
import style0 from "./DatabaseSearch.vue?vue&type=style&index=0&id=3d3b492a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports